Namespace 'Customer.Ticket'

class Customer.Ticket.InstagramStickerResponseView extends Backbone.View
  template: JST['backbone/templates/customer/ticket/sticker/instagram_sticker_response']
  className: 'instagram-sticker-response'

  initialize: (name) =>
    @sticker = new Customer.Ticket.InstagramStickerView(name)

  render: =>
    @$el.append(@sticker.render().el)
    @$el.find('.sticker').prepend(@template())
    @$el.find('i.icon-remove').click(@destroy)
    @

  getName: =>
    @sticker.getName()

  destroy: =>
    @trigger('remove:sticker')
    @remove()
